module.exports = __webpack_public_path__ + "static/media/pdf_icon.a87b6b85.svg";